import { Package, Users, Bell } from 'react-feather';

/**
 * Sprint 2 production sidebar.
 *
 * Production users see ONLY:
 *   - Produktionsvy (Sprint 4 - placeholder for now)
 *   - Kundlista in read-only mode (no MRR/prices/pipeline)
 *   - Notification settings
 */

const leveransSection = {
  title: 'Leverans',
  pages: [
    {
      href: '/produktion/produktionsvy',
      title: 'Produktionsvy',
      icon: Package,
    },
    {
      href: '/produktion/kundlista',
      title: 'Kundlista',
      icon: Users,
    },
  ],
};

const driftSection = {
  title: 'Drift',
  pages: [
    {
      href: '/produktion/notifikationer',
      title: 'Notifikationsinställningar',
      icon: Bell,
    },
  ],
};

const navItems = [leveransSection, driftSection];

export default navItems;
